import { BASE_RECIPIENT } from '@autosign/constants'
import { IconCircleFilled, TablerIconsProps } from '@tabler/icons-react'
import { resortRecipients } from 'bff'
import { Color, Recipient } from 'database'
import { translate } from 'i11n'
import { cn } from 'ui'
import { getColorHex } from '../utils/getColorHex'

export const mapRecipientLabel = (
  recipient: Recipient,
  index: number,
  self: Recipient[]
) => {
  switch (recipient.role) {
    case BASE_RECIPIENT.role:
      return (
        recipient.name ||
        recipient.email ||
        translate(`recipients.roles.${recipient.role}`)
      )

    default:
      const contextAwareIndex = resortRecipients(
        self.filter(r => r.role === recipient.role)
      ).findIndex(r => r.id === recipient.id)

      return (
        recipient.name ||
        recipient.email ||
        `${translate(`recipients.roles.${recipient.role}`)} ${
          contextAwareIndex + 1
        }`
      )
  }
}

export const RecipientItemInfo = ({
  children,
}: {
  children: React.ReactNode
}) => {
  return <div className='flex flex-col'>{children}</div>
}

export const RecipientItemLabel = ({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) => {
  return <span className={cn(className)}>{children}</span>
}

export const RecipientItemMark = ({
  color,
  className,
  icon: Icon,
}: {
  color: Color
  className?: string
  icon?: React.ComponentType<TablerIconsProps>
}) => {
  if (Icon)
    return (
      <Icon
        style={{
          color: getColorHex(color),
        }}
        className={cn('size-4 mt-1', className)}
      />
    )

  return (
    <IconCircleFilled
      style={{
        color: getColorHex(color),
      }}
      className={cn('size-4 mt-1', className)}
    />
  )
}

export const RecipientItem = ({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) => {
  return (
    <div
      className={cn('flex flex-row items-start space-x-2 relative', className)}
    >
      {children}
    </div>
  )
}
